import { render } from "./HalamanFatwa.vue?vue&type=template&id=2719c54c&scoped=true"
import script from "./HalamanFatwa.vue?vue&type=script&lang=js"
export * from "./HalamanFatwa.vue?vue&type=script&lang=js"

import "./HalamanFatwa.vue?vue&type=style&index=0&id=2719c54c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2719c54c"]])

export default __exports__